// extracted by mini-css-extract-plugin
export default {"item":"contact-item_item__-H2Sf","icon":"contact-item_icon__gOiAX","text":"contact-item_text__UNhyk"};